var MM = (function ($, WS, GLOBALS) {
	var cls, my;

	cls = {};

	my = {
		site: {

			whitebox: WS.WhiteBox({
					'root': $("#shell"),
					'elements': [
						$("<a>", {
							'href': '#',
							'class': 'close'
						}).text("Close").append(
							$("<span>")
						).bind("click", function(event) {
							event.preventDefault();
							my.site.whitebox.hide();
						})
					]
				}, {
					'overlay': {
						'load': {
							'callback': function(options, bgoptions) {
								return true;
							}
						},
						'hide': {
							'callback': function() {
								return true;
							}
						}
					}
				}),

			ui:{
				$doc: $(document.body),
				$window: $(window),
				$navigationBar: $('#header .bottom'),
				$navigationColumn: $('#header .bottom .navigation .level-1'),
				$navigationHeaders: $('#header .bottom .navigation .level-1 > a'),
				$carousels: $('.carousel'),
				$forms: $('form:not(.noparse):not(.ws-form)'),
				$maps: $('.map'),
				$mapsAddressDetails: $('.map .overlay .details'),
				$mapsAddressLinks: $('.map .overlay .links'),
				donateBlock: {
					currencySymbol: window.GLOBALS.currency_symbol,
					afterCurrencySymbol: window.GLOBALS.after_currency_symbol,
					$priceOneChild: $('.block.donate .amount .copy'),
					$slider: $('.block.donate .slider'),
					$donateButton: $('.block.donate .donate.button'),
					$amountImage: $('.block.donate .amount .image'),
					$amountCopy: $('.block.donate .amount .copy'),
					$amountDetails: $('.block.donate .details-wrapper'),
					$projectsSelect: $('.block.donate #projects'),
					$fundButton: $('.block.donate .fund.button'),
					$subscriptionOption: $('#frm-donate-subscribe input[name=subscription]')
				},
				socialBlock: {
					$blockSocial: $('.block.social'),
					$hoverContent: $('.block.social .hover-content'),
					$blockPlatform: $('  .block.social .facebook,' +
										'.block.social .twitter,' +
										'.block.social .instagram')
				},
				$plateStackBlockPlaceHolder: $('.block.has-plates .plate-stack'),
				$plateRoundabout: $('.roundabout'),
				$counter: $('.counter'),
				$timeline: $('.timeline'),
				child31Block: {
					$block: $('div[class$=child-31-header],.youtube-header div[class*=has-video]'),
					$inner: $('div[class$=child-31-header] .inner,.youtube-header div[class*=has-video] .inner'),
					$header: $('div[class$=child-31-header] .title,.youtube-header div[class*=has-video] .title'),
					$button: $('div[class$=child-31-header] .button,.youtube-header div[class*=has-video] .button'),
					$copy: $('div[class$=child-31-header] .copy,.youtube-header div[class*=has-video] .copy'),
					$video: $('div[class$=child-31-header] video,.youtube-header div[class*=has-video] video')
				},
				$flashMessage: $('.flash-message'),
				$facebookShareButton: $('.button.share-facebook'),
				$twitterShareButton: $('.button.share-twitter'),
				$twibbonShareButton: $('.button.share-twibbon'),
				$resourceButton: $('.document.link'),
				$projectDonateInput: $('.block #frm-donate-amount, .block #frm-project-donate-amount'),
				$projectDonateDisplay: $('.block .gift-aid-val'),
				$projectDonateButton: $('.donate-project'),
				$projectDonateBlock: $('.block.project-view-donate'),
				$projectSearchLoadMoreButton: $('.featured-projects .load-more'),
				$projectSearchTable: $('.featured-projects .project-search'),
				$confirmLinks: $('.confirm'),
				$interactiveIcon: $('.icon.interactive'),
				$mobileComingSoonBanner: $('.mobile-coming-soon'),
				$video: $('video'),
				$projectPageMaps: $('.wsfp.project-page .maps, .wsfp.project-report-page .maps'),
				$projectPagePagination: $('.wsfp.project-page .ajax-paginate'),
				$paginatedNews: $('.news-and-blogs .news-grid-container'),
				$geoRedirect: $('.geo-redirect-modal'),
				$responsorConfirm: $('.responsor-confirm'),
				$responsorDecline: $('.responsor-decline'),
				$fundraisingSummaryToggle: $('.fundraising-summary-toggle'),
				$fundraisingSummaryContainer: $('.fundraising-summary')
			},

			enable: function () {
				// Hopefully resolves repaint issue on ie8
				$('.ie8 .block.fundraising form').addClass('z').removeClass('z');

				// Table within content hack :(
				$('table').addClass('table');

				// Overrides ws form error messages for different site languages
				if (window.TRANSLATE) {
					window.WS.Form.Messages = {
						'general_error': window.TRANSLATE.wsfp_required,
						'field_value': window.TRANSLATE.wsfp_form_field_value,
						'field_mismatch': window.TRANSLATE.wsfp_form_field_mismatch,
						'tab_step_prefix': '',
						'type_email': window.TRANSLATE.wsfp_form_type_email,
						'type_number': window.TRANSLATE.wsfp_form_type_number,
						'type_regex': window.TRANSLATE.wsfp_form_type_regex,
						'type_date': window.TRANSLATE.wsfp_form_type_date,
						'value_min': window.TRANSLATE.wsfp_form_value_min,
						'value_max': window.TRANSLATE.wsfp_form_value_max,
						'value_min_len': window.TRANSLATE.wsfp_form_value_min_len,
						'value_max_len': window.TRANSLATE.wsfp_form_value_max_len,
						'did_you_mean': window.TRANSLATE.wsfp_form_did_you_mean
					};
				}

				// observe [input], update [display] and [total]
				WS.paymentCC({
					'selectors': {
						'display': '.gateway-charge-val',
						'total': '.gateway-total',
						'input': 'input[name="amount"]'
					}
				});

				// animate plates and coins
				if ($('.fact-children-fed') || $('.fact-children-fed')) {
					new WS.StoryBoard('.block', {
						'fact-children-fed': {
							'delay': -450,
							'nodes': [{
								'selector': '.anim-1',
								'properties': {
									'top': [null, -120],
									'left': [null, -270]
								}
							},{
								'selector': '.anim-2',
								'properties': {
									'top': [null, -20],
									'right': [null, -300]
								}
							}]
						},
						'fact-projects-funded': {
							'delay': -650,
							'nodes': [{
								'selector': '.euros-top',
								'properties': {
									'top': [null, -150]
								}
							},{
								'selector': '.pounds-top',
								'properties': {
									'top': [null, -130]
								}
							}, {
								'selector': '.dollars-bottom',
								'properties': {
									'bottom': [null, -140]
								}
							},{
								'selector': '.euros-bottom',
								'properties': {
									'bottom': [null, -180]
								}
							}]
						}
					});
				}

				// remove WS.Access until the timing of keystrokes is tweaked
				window.access = WS.Access(null, my.site.whitebox);

				my.site.parseSelects();

				// Parse redactor blocks
				my.site.parseRedactor();

				// Instantiate main navigation controller
				my.site.navigationController.enable( my.site.ui.$window,
												my.site.ui.$navigationBar,
												my.site.ui.$navigationColumn,
												my.site.ui.$navigationHeaders,
												'50px' );

				// Instantiate counter in any block
				if (!($('html').hasClass('ie8'))) {
					my.site.widgets.counter.enable(my.site.ui.$counter);
				}

				// Instantiate all carousels on page
				my.site.carousel.enable(my.site.ui.$carousels);

				// Validate any forms on the page
				my.site.forms.enable(my.site.ui.$forms);

				// Instantiate all maps on page
				my.site.maps.enable(my.site.ui.$maps,
									my.site.ui.$mapsAddressDetails,
									my.site.ui.$mapsAddressLinks);

				// Instantiate donate block sliders & buttons
				my.site.widgets.donateBlock.enable(my.site.ui.donateBlock);

				// Instantiate platestacker
				my.site.widgets.plateStackBlock.enable(my.site.ui.$plateStackBlockPlaceHolder);

				// Instantiate plateroundabout
				my.site.widgets.plateRoundabout.enable(my.site.ui.$plateRoundabout);

				// Instantiate timeline carousel
				my.site.timeline.enable(my.site.ui.$timeline);

				// Child 31 video
				my.site.widgets.child31Block.enable(my.site.ui.child31Block,
													window.location.hash,
													my.site.ui.$doc);

				// enable flash message slide down if exists
				my.site.flashMessage.enable(my.site.ui.$flashMessage);

				// Set up any facebook & twitter share buttons
				my.site.widgets.socialButtons.enable(my.site.ui.$facebookShareButton,
													 my.site.ui.$twitterShareButton,
													 my.site.ui.$twibbonShareButton);

				// Project page donate panel update gift aid calculation
				my.site.widgets.projectDonateGiftCalc.enable(my.site.ui.$projectDonateInput,
															 my.site.ui.$projectDonateDisplay);

				// Enable animate to donate panel anchor point on a project page
				my.site.widgets.projectDonateDonateButton.enable(my.site.ui.$projectDonateButton,
																 my.site.ui.$projectDonateBlock,
																 my.site.ui.$doc);

				// Enable ajax loading of next page for project search load more button
				my.site.widgets.projectSearchLoadMoreButton.enable(my.site.ui.$projectSearchLoadMoreButton,
																   my.site.ui.$projectSearchTable);

				// Enable confirm links
				my.site.widgets.confirmLinks.enable(my.site.ui.$confirmLinks);

				// Enable interactive icons
				my.site.widgets.iconInteractiveScroll.enable(my.site.ui.$interactiveIcon);

				// Enable mobile version of site
				my.site.widgets.mobileVersion.enable(my.site.ui.$video,
													 my.site.ui.$mobileComingSoonBanner);

				// Enable project page maps and pagination
				my.site.projectPage.enable(my.site.ui.$projectPageMaps,
										   my.site.ui.$projectPagePagination);

				// Enable news pagination
				my.site.newsPagination.enable(my.site.ui.$paginatedNews);
				my.site.newsPagination.expandingFilters(my.site.ui.$paginatedNews);

				// Enable social share
				my.site.socialLogin.enable();

				// Enable redirect modal
				my.site.geoRedirect(my.site.ui.$geoRedirect);

				// Enable responsor modals
				my.site.responsorConfirmation();

				// Enable fundaising Summary display toggle
				my.site.toggleFundraisingSummary();

				// Big Family Christmas wrapping paper animation
				if ($('#wrapping-paper').length) {
					$(document).ready(function() {
						setTimeout(function() {
							$('#wrapping-paper').addClass('tear-paper');
							$('#wrap-div').addClass('roll');
							$('.paper').addClass('animating');
						}, 2000);
					});
				}

				// Cookie banner
				my.site.cookie_notification();

				my.site.facebook_events();
			},

			parseSelects: function() {
				$("select.style:not(.styled)").each(function() {
					var $select = $(this), id, classes, $proxy, $label, selected_label;

					selected_label = function() {
						if ($select[0].selectedIndex !== -1) {
							return $select.find("option:selected").html();
						}
					};

					id = $select.attr("id");
					classes = $select[0].className;

					$proxy = $("<div>", {
						'class': 'select-proxy'
					}).insertBefore($select);

					if (classes) {
						$proxy.addClass(classes);
					}

					if (id !== "" && id !== undefined) {
						$proxy.prop("id", "proxy-for-" + id);
					}

					$select.appendTo(
						$proxy
					).bind("change", function() {
						$label.html(selected_label());
					}).bind("focus blur", function() {
						if (event.type === "focus") {
							$proxy.addClass("focus");
						} else {
							$proxy.removeClass("focus");
						}
					}).before(
						$label = $("<span>").html(selected_label())
					).addClass(
						"styled"
					);
				});
			},

			parseRedactor: function() {
				var $textareas,
				    options;

				$textareas = $("textarea.redactor");

				options = {
					'minHeight': 200,
					'maxHeight': 700,
					'buttons': ['bold', 'italic', 'link'],
					'toolbarFixed': false
				};

				if ($textareas.length > 0 && !($('html').hasClass('ie8'))) {
					WS.Include.load("/includes/global_js/redactor.min.js", function() {
						if (window.GLOBALS.language_code && window.GLOBALS.language_code != 'en') {
							options.lang = window.GLOBALS.language_code;
							WS.Include.load("/includes/global_js/redactor-lang/" + window.GLOBALS.language_code + ".js", function() {
								$textareas.each(function() {
									my.site.initRedactor($(this), options);
								});
							});
						} else {
							$textareas.each(function() {
								my.site.initRedactor($(this), options);
							});
						}
					});
				}
			},

			initRedactor: function($textarea, options) {
				if ($textarea.hasClass('redactor--no-links')) {
					$textarea.redactor($.extend({}, options, {
						'buttons': ['bold', 'italic'],
						'pastePlainText': true,
						'convertLinks': false,
						'convertUrlLinks': false,
						'deniedTags': ['a']
					}));
				} else {
					$textarea.redactor(options);
				}
			},

			genericSelectForwarding: function($select, new_window) {
				var url;

				if ($select && $select.length === 1) {
					url = $select.val();

					if (new_window) {
						window.open(url);
					} else {
						location.href = url;
					}
				}
			},

			navigationController: {

				barOpenHeight: '',

				minHeight: '50px',

				enable: function ($window, $bar, $columns, $header, minHeight) {

					my.site.navigationController.init($bar, $columns, $header, minHeight);

					// Recalculate navigation height on resize and (re)apply event handlers
					$window.bind('resize', function () {
						if ( !my.site.widgets.mobileVersion.isMobile() ) {
							$bar.css({'height': 'auto', 'visibility': 'hidden'});
							my.site.navigationController.barOpenHeight = my.site.ui.$navigationBar.css('height');
							$bar.css({'height': my.site.navigationController.minHeight, 'visibility': 'visible'});
						}
					});

				},

				init: function ($bar, $columns, $header, minHeight) {
					$bar.css({'height': 'auto', 'visibility': 'hidden'});
					my.site.navigationController.barOpenHeight = my.site.ui.$navigationBar.height();

					$bar.css({'height': my.site.navigationController.minHeight});
					$bar.css({'visibility': 'visible'}).animate({'opacity': 1.0});

					// Remove any handlers before (re)applying
					$bar.unbind('mouseenter');
					$bar.unbind('mouseleave');
					$columns.unbind('mouseenter');
					$columns.unbind('mouseleave');

					if ( my.site.widgets.mobileVersion.isMobile() ) {

						$('.mobile-nav-icon').on('click', function () {
							if ( $bar.hasClass('open') ) {
								$bar.removeClass('open');
								$bar.stop();
								$bar.animate({'height': my.site.navigationController.minHeight});
							} else {
								$bar.addClass('open');
								$bar.stop();
								$bar.animate({'height':my.site.navigationController.barOpenHeight}, 250, 'easeOutCubic');
							}
						});

					} else {

						$bar.dwell(function() {
							$bar.addClass('open');
							$bar.stop();
							$bar.animate({'height':my.site.navigationController.barOpenHeight}, 250, 'easeOutCubic');
							$('.mobile-nav-icon, .navigation').addClass('open');
						}, 5).bind("mouseleave", function() {
							$bar.removeClass('open');
							$bar.stop();
							$bar.animate({'height': my.site.navigationController.minHeight});
							$('.mobile-nav-icon, .navigation').removeClass('open');
						});

					}


					if ( !my.site.widgets.mobileVersion.isMobile() ) {
						$columns.on('mouseenter', function () {
							var $this = $(this);
							$columns.stop();
							$columns.animate({'opacity':'0.2'}, 300);
							$this.stop();
							$this.animate({'opacity':'1'});
						});
					}

					$columns.on('mouseleave', function () {
						$columns.stop();
						$columns.animate({'opacity':'1'}, 300);
					});
				}
			},

			carousel: {
				enable: function ($carousel, $carouselNavigation, $carouselNavigationNew) {
					if ($carousel.length) {
						WS.Include.load('/includes/global_js/ws.carousel.js', function () {
							// For each carousel markup block found instantiate ws carousel for it
							$carousel.each(function (idx, elm) {
								var carousel, $nav, $navNew,
									$elm = $(elm),
									name = $elm.attr('class').split(' ').pop();

								// ASSUMPTION: if large carousel on homepage then it's the one and only interactive carousel
								if ( $elm.closest('.homepage').length && $elm.hasClass('carousel-large') > -1 ) {
									name = 'homepage-carousel';
								}

								switch (name) {

									case 'homepage-carousel':
										carousel = new window.WS.Carousel($elm, {
											'animation': {
												'automated': false,
												'delay': 5,
												'duration': 0.5,
												'type': window.WS.Carousel.Animations.fade
											},
											'callbacks': {
												'pre_advance': function () {
													var carouselName = $elm.parent().parent().attr('class').split(' ').pop(),
														$current = this.animation.current;

													return true;
												},
												'post_advance': function () {
													var $current = this.animation.current;

													// start counter
													if ($current.find('.counter').length) {
														$current.find('.counter').find('div').text($current.find('.counter').attr('data-value'));
														if(carousel.animation.index+1 < this.items.length) {
															setTimeout(function() {
																carousel.go(1);
															}, 5000);
														}
													} else {
														if(carousel.animation.index+1 < this.items.length) {
															setTimeout(function() {
																carousel.go(1);
															}, 5000);
														}
													}
													return true;
												}
											},
											'navigation': false,
											'pagination': false
										});

										// start counter
										setTimeout(function(){
											carousel.items[0].find('.counter').find('div').text(carousel.items[0].find('.counter').attr('data-value'));
											setTimeout(function() {
													carousel.go(1);
												}, 5000);
											},500);
										break;

									default:
										carousel = new window.WS.Carousel($elm, {
											'animation': {
												'automated': false,
												'delay': 5,
												'duration': 0.1,
												'type': window.WS.Carousel.Animations.fade
											},
											'callbacks': {
												'post_advance': function () {
													var carouselName = $elm.parent().parent().attr('class').split(' ').pop();
													return true;
												}
											},
											'navigation': true,
											'pagination': false
										});

										$nav = $elm.parent().find('.navigation');		// current carousel navigation
										$nav.addClass('button');						// add button class to navigation
										$navNew = $elm.find('.navigation-container');   // new home for carousel navigation

										// Move navigation in to new place within bootstrap grid
										$nav.appendTo($navNew);
										break;
								}
							});
						});
					}
				}
			},

			forms: {
				enable: function ($forms) {
					if ($forms.length) {
						my.site.forms.initValidation($forms);
					}

					my.site.forms.ageCheck();
				},

				ageCheck: function () {
					var $forms = $('form');
					$($forms).each(function (i, form) {
						var $form = $(form),
								 $ageCheck = $form.find('input[name="age_check"]');

						if ($ageCheck.length > 0) {
							var $submit = $form.find('button[type="submit"]');
							$submit.attr('disabled', true);

							$ageCheck.on('change', function (evt) {
								var $target = $(evt.target);
								if ($target.is(':checked')) {
									var value = $target.val();

									if (value === 'No') {
										$submit.attr('disabled', true);
										$('.frm-check-no-message').fadeIn();
									} else if (value === 'Yes') {
										$('.frm-check-no-message').fadeOut();
										$submit.attr('disabled', false);
									}
								}
								// if (value === 'Yes') {
								// 	$submit.attr('')
								// }
							});
						}
					});
				},

				initCustomActions: function ($form, wsform) {
					$form.find("select.select-forward").each(function() {
						$(this).bind("change", function(event) {
							my.site.genericSelectForwarding($(this));
						});
					});

					window.setTimeout(function() {
						if ($form.find($(".g-recaptcha")).length > 0) {
							wsform.add_field("g-recaptcha-response", {
								"require": true
							});

							window.recaptchaCallback = function(token) {
								if (token !== "") {
									$form.find(".field.captcha p.error").addClass("v-hidden");
								}
							}

							window.recaptchaExpire = function() {
								wsform.remove_field("g-recaptcha-response");
							}
						}
					}, 3000);

					// Assign actions to each steps' continue button except last step which is a submit button
					if ($form.hasClass('tabs')) {
						// Make tabs not clickable
						$form.find('.form-tab-control li a').each(function (idx, elm) {
							$(elm).off();
							$(elm).on('click', function (e) {
								e.preventDefault();
							})
						});

						// If user presses enter then trigger on click event below
						$form.on('keydown', function (e) {
							if (e.keyCode === 13 && e.target.nodeName != 'TEXTAREA') {
								e.preventDefault();
								$form.find('.continue').trigger('click', [true]);
							}
						});

						$form.find('.continue').on('click', function (e) {
							var $button       = $(this),
								$currentStep  = $form.find('.form-tab-control li.active'),		  // current active step
								$nextStep     = $form.find('.form-tab-control li.active').next(), // next step
								$previousStep = $form.find('.form-tab-control li.active').prev(), // previous step

								activeTabIndex          = $form.find('.form-tab-control li').index($currentStep),
								highestTabIndex         = $form.find('fieldset').length - 1,
								nextTabIndex			= ((activeTabIndex + 1) > highestTabIndex) ? highestTabIndex : (activeTabIndex + 1),
								previousTabIndex		= ((activeTabIndex - 1) < 0) ? 0 : (activeTabIndex - 1),
								$currentTabGroup        = $form.find('fieldset').eq(activeTabIndex),
								$nextTabGroup			= $form.find('fieldset').eq(nextTabIndex),
								$previousTabGroup		= $form.find('fieldset').eq(previousTabIndex),
								$currentTabGroupFields  = $currentTabGroup.find('[id^=freeform]'),
								currentTabGroupErrCount = 0;

							// Remove required class from all form elements
							$form.find('.required').each(function (idx, elm) {
								var $elm = $(elm);
								$elm.removeClass('required');
							});

							// validate fields in current tab group
							$currentTabGroupFields.each(function (idx, elm) {
								if (!wsform.validate_field(elm.name).valid) {
									wsform.add_fault(wsform.validate_field(elm.name));

									if ($currentTabGroup.find('.continue').length) {
										wsform.report($currentTabGroup.find('.continue'));
									} else {
										wsform.report($currentTabGroup.find('.submit'));
									}

									currentTabGroupErrCount += 1;
								} else {
									wsform.remove_fault(elm.name);
									$form.find('[name="' + elm.name + '"]').closest(".required").each(function (idx, elm) {
										var $elm = $(elm);
										$elm.removeClass('required');
										$elm.find(".required").removeClass("required");
									});
								}
							});

							// If no errors found progress to next tab
							if (currentTabGroupErrCount === 0) {
								$('html, body').animate({'scrollTop':$form.closest('.block').offset().top}, 'slow');
								wsform.tab(nextTabIndex);
							}
						});
					}

					$form.bind("form:error", function(event, form, faults) {
						$(faults).each(function(index, elem) {
							if (elem["name"] === "g-recaptcha-response") {
								if ($(elem["element"][0]).val() === "") {
									$(elem["element"][0]).closest(".field.captcha").find(".error").removeClass("v-hidden");
								}
							}
						});
					});

					switch($form[0].id) {
						case 'frm-gdpr-subscribe': case 'frm-consent':
							(function () {
								if (window.GLOBALS.language_code === "hr") {
									wsform.remove_field("updates_post");
								}
							}());
							break;
						case 'frm-contact':
							(function () {
								var icon,
									$subject = $form.find('#freeform_subject');

									$subject.change(function () {
										var $selectedItem = $subject.find(':selected'),
											selectedItemClass = $selectedItem.attr('class');

										$form.find('.icon').hide();

										if ($form.find('.icon.' + selectedItemClass).length) {
											$form.find('.icon.' + selectedItemClass).show();
										} else {
											$form.find('.icon.default').show();
										}
									});

								if ( (window.location.search.indexOf('reason') > 0) ) {
									$('html, body').animate({'scrollTop':$form.closest('.block').offset().top}, 'slow');
								}

								if (window.GLOBALS.language_code === "hr") {
									wsform.remove_field("updates_post");
								}

								if ($form.find(".unsubscribe").length > 0) {
									wsform.remove_field("reason");
									wsform.remove_field("message");
									wsform.remove_field("updates_email");
									wsform.remove_field("updates_post");

									wsform.add_field("address", {
										'require': true
									});

									wsform.add_field("postcode", {
										'require': true
									});

									$("select[name='country']").change(function() {
										console.log('country change: ' + this.value);
										if (this.value === "US" || this.value === "CA") {
											wsform.add_field("province", {
												'require': true
											});
										} else {
											wsform.remove_field("province");
										}
									}).change();

									$("input[name='unsubscribe_post']").change(function() {
										if (this.checked) {
											$form.find(".unsubscribe-both, .unsubscribe-post").removeClass("hidden");
										} else {
											$form.find(".unsubscribe-post").addClass("hidden");
											if ($("input[name='unsubscribe_email']:checked").length === 0) {
												$form.find(".unsubscribe-both").addClass("hidden");
											}
										}
									});

									$("input[name='unsubscribe_email']").change(function() {
										if (this.checked) {
											$form.find(".unsubscribe-both, .unsubscribe-email").removeClass("hidden");
										} else {
											$form.find(".unsubscribe-email").addClass("hidden");
											if ($("input[name='unsubscribe_post']:checked").length === 0) {
												$form.find(".unsubscribe-both").addClass("hidden");
											}
										}
									});
								}
							}());
							break;

						case 'frm-subscription':
							(function () {
								$form.on('form:error', function(e, form, faults) {
									//remove existing errors
									$('#frm-subscription').find('input').removeClass('error');
									//add error style to fields
									$.each(faults, function(i, item){
										var $errorField = $('[name="' + faults[i].name + '"]');
										$errorField.addClass('error');
									});
								});
							}());
							break;

						case 'frm-donate-subscribe':
							(function () {
								var ulWidth, colWidth, $li;

								// Add ul to form
								if($form.find('input[type="radio"]').length > 0) {
									$('<ul class="options"></ul>').appendTo($form);

									$form.find('input').each(function (idx, elm) {
										var mrgLft, mrgRgt,
											$label = $form.find('label[for="' + elm.id +  '"]');

										// Create new li
										$li  = $('<li class="option"></li>');

										// Add input to li
										$(this).appendTo($li);

										// Add label to li
										$label.appendTo($li);

										// If first label then make active
										if (idx === 0) {
											$label.addClass('active');
										}

										// Add new li to ul
										$li.appendTo( $form.find('.options') );
									});

									// Get width of ul WITH contents
									ulWidth  = $form.find('ul').width();

									$form.find('.option').on('click', function () {
										var leftPos = $(this).position().left - 8,
											$slide  = $form.find('.slide'),
											$labels = $form.find('label'),
											$label  = $(this).find('label');

										$labels.removeClass('active');
										$label.addClass('active');
										$slide.stop();
										$slide.animate({'left':leftPos});
									});

									// Set slide to currently selected radio button
									$form.find('.option :checked').trigger('click', [true]);
								}


							}());
							break;

						case 'frm-select-project-type':
							(function () {
								var $selectElm     = $form.find('select'),
									$submitButton  = $form.find('.control.center button');
									// $instructions = $form.find('.instruction');

								// $instructions.each(function() {
								// 	if(window.GLOBALS.country_code === 'GB' && window.GLOBALS.aid_match == true) {
								// 		if($(this).hasClass('instruction-17')) {
								// 			$(this).find('p').append("<br /><br />From 28 September to 28 December 2015, the <a href='/get-involved/feed-our-future/'>UK Government will double</a> every personal donation made to Mary's Meals.");
								// 		}
								// 		else if($(this).hasClass('instruction-14')) {
								// 			$(this).find('p').append("<br /><br />The <a href='/get-involved/feed-our-future/'>UK Government is doubling</a> personal donations made to Mary’s Meals from 28 September to 28 December 2015. Please note that only the funds you donate can go towards feeding costs at your chosen school. The match funding provided by the UK Government must be spent on feeding hungry children in NEW schools being added to our feeding programmes in Malawi and Zambia.");
								// 		}
								// 	}
								// });

								$selectElm.on('change', function () {
									var id = $form.find('option:selected').data('id');
									$form.find('.image').addClass('hide');
									$form.find('.instruction').addClass('hide');
									$form.find('.image-' + id).removeClass('hide');
									$form.find('.instruction-' + id).removeClass('hide');
								});

								$submitButton.on('click', function (e) {
									e.preventDefault();
									if ($selectElm.val() && $selectElm.val() !== '') {
										window.location.href = $selectElm.val();
									}
								});

							}());
							break;

						default:
							break;
					}
				},

				initValidation: function ($forms) {
					var wsform;

					$forms.each(function (idx, elm) {
						var options, fields,
						$form = $(elm);

						//console.log($forms, 'fired');
						// TEMP FOR RAY
						if ($form[0].id === 'frm-register-user' ||
							$form[0].id === 'frm-create-project' ||
							$form[0].id === 'frm-login-user' ||
							$form[0].id === 'frm-forgotten-password') {
							return;
						}

						options = {
							'popup': {
								'alignment': window.WS.Form.Alignments.bottom_right
							},
							'field': {
								'popup': {
									'alignment': window.WS.Form.Alignments.bottom_right
								}
							},
							'submit': {
								'callback': my.site.forms.genericSubmitCallback
							}
						};

						// If tab class exists on form, form contains fieldsets
						if ($form.hasClass('tabs')) {
							options.tabs = true;
						}

						switch($form[0].id) {
							case 'frm-contact':
								fields = {
									'reason': {
										'require': true,
										'min_length': 2
									},
									'title': true,
									'telephone': false,
									'subject': {
										'require': true
									},
									'first_name': true,
									'last_name': true,
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email,
										'cascade': {
											'fields': {
												'confirm_email': {
													'require': true,
													'type': window.WS.Form.ValueTypes.Email,
													'duplicate_of': 'email',
													'messages': {
														'mismatch': window.TRANSLATE.wsfp_email_mismatch
													}
												}
											}
										}
									},
									'message': true,
									'postcode': false,
									'address': false,
									'updates_email': true,
									'updates_post': true,
									'province': false,
									'city': false,
								};
								break;
							case 'frm-consent':
								fields = {
									'title': true,
									'first_name': true,
									'last_name': true,
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email,
										'cascade': {
											'fields': {
												'confirm_email': {
													'require': true,
													'type': window.WS.Form.ValueTypes.Email,
													'duplicate_of': 'email',
													'messages': {
														'mismatch': window.TRANSLATE.wsfp_email_mismatch
													}
												}
											}
										}
									},
									'postcode': true,
									'address': true,
									'country': true,
									'updates_email': {
										'require': true,
										'popup': {
											'alignment': window.WS.Form.Alignments.bottom_right
										}
									},
									'updates_post': {
										'require': true,
										'popup': {
											'alignment': window.WS.Form.Alignments.bottom_right
										}
									},
									'province': false,
								};
								break;
							case 'frm-gdpr-subscribe':
								fields = {
									'title': true,
									'telephone': true,
									'first_name': true,
									'last_name': true,
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email,
										'cascade': {
											'fields': {
												'confirm_email': {
													'require': true,
													'type': window.WS.Form.ValueTypes.Email,
													'duplicate_of': 'email',
													'messages': {
														'mismatch': window.TRANSLATE.wsfp_email_mismatch
													}
												}
											}
										}
									},
									'postcode': true,
									'address': true,
									'town_or_city': true,
									'telephone': true,
									'country': true,
									'updates_email': true,
									'updates_post': true,
									'province': false,
								};
								break;
							case 'frm-newsletter-subscribe':
								fields = {
									'first_name': true,
									'last_name': true,
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email
									},
									'newsletter': {
										'require': false,
										'type': window.WS.Form.ValueTypes.RegExp,
										'regexp': new RegExp('^yes$')
									}
								};
								break;
							case 'frm-subscription':
								fields = {
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email
									},
									'first_name': true,
									'last_name': true
								};
								options.submit.callback = function() {
									$.ajax($('#frm-subscription').attr('action'),{
										data: $('#frm-subscription').serialize(),
										method: 'post',
										success: function(data) {
											if (data.success) {
												$.ajax(window.GLOBALS.ajax_url,{
													data: {
														action: 'set_flash',
														type: 'success',
														message: 'wfsp_subscribe_success'
													},
													success: function() {
														location.href = location.href+'?subscribe'+Math.floor(Math.random() * 10000000);
													}
												});
											} else {
												//remove existing errors
												$('#frm-subscription').find('input').removeClass('error');
												//add error style to fields
												$.each(data.errors, function(key, item){
													var $errorField = $('[name="' + key + '"]');
													$errorField.addClass('error');
												});
											}
										}
									});
									return false;
								};
								break;
							case 'frm-edit-user-update-details':
								fields = {
									'first_name': true,
									'last_name': true,
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email
									},
									'password': true
								}
								break;
							case 'frm-edit-user-update-password':
								fields = {
									'password': true,
									'new_password': {
										'require': true,
										'cascade': {
											'fields': {
												'confirm_new_password': {
													'require': true,
													'duplicate_of': 'new_password'
												}
											}
										}
									}
								}
								break;
							case 'frm-technical-support':
								fields = {
									'email': true,
									'issue': true,
									'gather': true,
									'agree_terms': true
								};
								options.submit.callback = function() {
									$('#frm-technical-support input[name=width]').val(screen.width);
									$('#frm-technical-support input[name=height]').val(screen.height);
									$('#frm-technical-support input[name=colour_depth]').val(screen.colorDepth);
									$.ajax(window.GLOBALS.ajax_url,{
										data: $('#frm-technical-support').serialize(),
										method: 'post',
										success: function(response) {
											location.href = response.redirect;
										}
									});
									return false;
								}
								break;
							case 'frm-offline-donation':
								fields = {};
								options.submit.callback = function () {
									var data   = $form.serializeObject(),
										amount = parseFloat(Number(data.value.replace(/[^0-9\.]+/g, ''))) * 100;

									// If 0 value passed throw error
									if (amount === 0) {
										this.message(window.TRANSLATE['wsfp_required'], $form.find('.button'), { 'popup' : { 'type' : WS.Form.MsgTypes.Error } });
										$form.find('[id$=donation-amount]').parent().addClass('required');
										return false;
									} else {
										$form.find('[id$=donation-amount]').parent().removeClass('required');
										return true;
									}

								}
								break;
							case 'frm-shed-bonus':
								fields = {
									'title': true,
									'first_name': true,
									'last_name': true,
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email,
										'cascade': {
											'fields': {
												'confirm_email': {
													'require': true,
													'type': window.WS.Form.ValueTypes.Email,
													'duplicate_of': 'email',
													'messages': {
														'mismatch': window.TRANSLATE.wsfp_email_mismatch
													}
												}
											}
										}
									},
									'postcode': true,
									'address': true,
									'where_did_you_buy': true,
									'updates_email': {
										'require': true,
										'popup': {
											'alignment': window.WS.Form.Alignments.bottom_right
										}
									},
									'updates_post': {
										'require': true,
										'popup': {
											'alignment': window.WS.Form.Alignments.bottom_right
										}
									}
								};
								break;
							case 'frm-generation-hope':
								fields = {
									'title': true,
									'first_name': true,
									'last_name': true,
									'email': {
										'require': true,
										'type': window.WS.Form.ValueTypes.Email,
										'cascade': {
											'fields': {
												'confirm_email': {
													'require': true,
													'type': window.WS.Form.ValueTypes.Email,
													'duplicate_of': 'email',
													'messages': {
														'mismatch': window.TRANSLATE.wsfp_email_mismatch
													}
												}
											}
										}
									},
									'telephone': false,
									'county': true,
									'country': true,
									'postcode': true,
									'address': true,
									'day': true,
									'month': true,
									'year': true,
									'how_did_you_hear_about_generation_hope': false,
									'where_do_you_plan_to_hold_your_screening': true,
									'what_is_the_name_of_your_screening_venue': true,
									'in_which_town_city_or_village_is_it_located': true,
									'how_many_people_do_you_expect_to_attend': true,
									'updates_email': {
										'require': true,
										'popup': {
											'alignment': window.WS.Form.Alignments.bottom_right
										}
									},
									'updates_post': {
										'require': true,
										'popup': {
											'alignment': window.WS.Form.Alignments.bottom_right
										}
									}
								};
								break;
						}

						//deal with custom forms
						if ($form.hasClass('custom-form')) {

							fields = {};
							$form.find(':input').each(function(){
									if($(this).is('[name*="email"]')) {
										fields[$(this).attr('name')] = {
											'require': true,
											'type': window.WS.Form.ValueTypes.Email
										};
									} else if($(this).hasClass('required-item')) {
										fields[$(this).attr('name')] = true;
									} else {
										fields[$(this).attr('name')] = false;
									}
							});
						}

						if (fields) {
							wsform = new WS.Form($form, options, fields);
						} else {
							$form.bind("submit", function(event) {
								event.preventDefault();

								if (my.site.forms.genericSubmitCallback.apply(this) !== false) {
									this.submit();
								}
							});
						}

						my.site.forms.initCustomActions($form, wsform);
					});
				},

				genericSubmitCallback: function() {
					var $form = $(this), data = {};

					if ($form.hasClass("select-forward") &&
						(data.$select = $form.find("select.select-forward")).length) {
						// form has the same class - perform the select forwarding on submission
						my.site.genericSelectForwarding(data.select);
					}
				}
			},

			maps: {
				wsgmap: null,

				enable: function ($map, $details, $links) {
					window.load_maps = function () {
						WS.Include.load('/includes/global_js/ws.gmap.js', function () {
								var mapName, $markers, markerIcon, markerIconActive,
									markerIndexes = [];

								// Instantiate google map
								my.site.maps.wsgmap = new window.WSGmap({
									'canvas': $('.map .gmap'),
									'map': {
										'center': new window.google.maps.LatLng(56.406900, -4.953730),
										'maxZoom': 16,
										'minZoom': 8,
										'zoom': 8,
										'zoomControlOptions': {
											'style': window.google.maps.ZoomControlStyle.LARGE,
											'position': window.google.maps.ControlPosition.LEFT_CENTER
										},
										'panControl': false,
										'zoomControl': true,
										'mapTypeControl': false,
										'scaleControl': false,
										'streetViewControl': false,
										'overviewMapControl': false
									}
								});

								// apply the map-settings for panControl and zoomControl to the streetView:
								my.site.maps.wsgmap.gmap.get('streetView').setOptions({
									'addressControl': false,
									'linksControl': false,
									'panControl': false,
									'zoomControlOptions': {
										'style': window.google.maps.ZoomControlStyle.LARGE,
										'position': window.google.maps.ControlPosition.LEFT_CENTER
									},
									'enableCloseButton': true
								});

								markerIcon = new window.google.maps.MarkerImage(
									'/global_images/where-we-work/marker.png',
									new window.google.maps.Size(41, 55), /* half */
									new window.google.maps.Point(0, 0)   /* 0, 0 - normal, 0, 55 - active */
								);

								markerIconActive = new window.google.maps.MarkerImage(
									'/global_images/where-we-work/marker.png',
									new window.google.maps.Size(41, 55), /* half */
									new window.google.maps.Point(0, 55)   /* 0, 0 - normal, 0, 55 - active */
								);

								//----

								// Which map are we initialising
								mapName = $map.attr('class').split(' ').pop();

								// Add markers from anochor elements with data attributes
								$markers = $map.find('.marker');

								$markers.each(function (idx, elm) {
									var $elm = $(elm),
										name = $elm.data('name'),
										label = $elm.data('label'),
										lat = $elm.data('lat'),
										lng = $elm.data('lng');

									// Add each marker to map
									markerIndexes.push(my.site.maps.wsgmap.add_marker(lat, lng, {
										'title': name,
										'icon': markerIcon
									}));
								});

								// When user clicks on marker, pan map to center marker
								$(my.site.maps.wsgmap.markers).each(function (idx, elm) {
									window.google.maps.event.addListener(elm, 'click', function () {
										var position = elm.position,
											title    = elm.title;

										// do we have an active marker?
										if (my.active_marker) {
											my.active_marker.setIcon(markerIcon);
										}

										// set this marker as active and keep a reference to it
										this.setIcon(markerIconActive);
										my.active_marker = this;

										// pan to position
										my.site.maps.wsgmap.gmap.panTo(position);
									});
								});

								$(my.site.maps.wsgmap.markers).each(function(idx, elm) {
									// When user clicks on marker, show appropriate address
									window.google.maps.event.addListener(elm, 'click', function() {
										var title = elm.title;

										$details.find('.address').hide();
										$details.find('.address.' + title).show();

										$links.find('a').removeClass('active-address');
										$links.find('a.' + title).addClass('active-address');

									});
								});

								// Make each link / label in the list change the map position
								$(markerIndexes).each(function(idx, elm) {
									var marker = my.site.maps.wsgmap.markers[markerIndexes[idx]], position, title;

									position = marker.position;
									title = marker.title;

									$links.find('.' + title).on('click', function(event) {
										event.preventDefault();

										// do we have an active marker?
										if (my.active_marker) {
											my.active_marker.setIcon(markerIcon);
										}

										// set this marker as active and keep a reference to it
										marker.setIcon(markerIconActive);
										my.active_marker = marker;

										// link states
										$links.find('a').removeClass('active-address');
										$(this).addClass('active-address');

										// pan to position, hide the addresses and show this addy
										my.site.maps.wsgmap.gmap.panTo(position);
										$details.find('.address').hide();
										$details.find('.address.' + title).show();
									});
								});

								// set the initial state
								var tmp_marker = my.site.maps.wsgmap.markers[markerIndexes[0]];
								tmp_marker.setIcon(markerIconActive);
								my.active_marker = tmp_marker;
								my.site.maps.wsgmap.gmap.panTo(my.active_marker.position);
								$($links.find('a')[0]).addClass('active-address');
								$details.find('.address').hide();
								$details.find('.address.' + my.active_marker.title).show();

						});
					};

					if ($map.find('.gmap').length) {
						WS.Include.load('//maps.google.com/maps/api/js?sensor=false&key=AIzaSyAUwxxUUbk6pO5PqDHI-yju86zhCkN_qmw&region=GB&callback=load_maps');
					}
				}
			},

			timeline: {
				enable: function ($timeline) {
						var carousel, TimelineComplete;
						if ( !my.site.widgets.mobileVersion.isMobile() ) {

							if ($timeline.length) {

								WS.Include.load('/includes/global_js/ws.carousel.js', function () {

									TimelineComplete = function(settings) {
										var my, cls;

										cls = function() {
											var carousel = this;

											$(this.items).each(function(slide_index) {
												my.prep.apply(carousel, [slide_index, (carousel.animation && slide_index === carousel.animation.index)]);
											});
										};

										my = {
											enable: function() {
												settings = ob_set(settings || {}, {
													'selectors': {
														'figure': '.figure',
														'animator': '.animator'
													},
													'classes': {
														'complete': 'complete'
													}
												});

												my.timers = {};
											},

											prep: function(index, animate) {
												var $animator;

												if (($animator = this.items[index].find(settings.selectors.animator)).length) {
													// animator container found - act, depending on sub-class
													switch (true) {
														case $animator.hasClass("aid-truck"):
															my.animations.slideFromLeft.apply(this, [$animator, animate]);
															break;

														case $animator.hasClass("counting-plates"):
															my.animations.countingPlates.apply(this, [$animator, animate]);
															break;
													}
												}
											},

											animations: {
												// animate a figure moving in from the far left, revealing the figure data once stopped
												 slideFromLeft: function($container, animate) {
													var $figure, metrics;

													if (($figure = $container.find(settings.selectors.figure)).length) {
														if (!(metrics = my.initialised($container))) {
															metrics = {
																'figure': {
																	'position': $figure.position(),
																	'width': $figure.width()
																}
															};

															my.initialised($container, true, metrics);
														}

														// re-set position
														$figure.stop().css({
															'position': 'absolute',
															'left': -metrics.figure.width + 'px'
														});

														if (animate) {
															// animate in
															$figure.animate({
																'left': metrics.figure.position.left + 'px'
															}, 2000, 'easeOutQuart', function() {
																my.complete($container);
															});
														}
													}
												},

												countingPlates: function($container, animate) {
													var a, b, $figure, $digit, $plates, text, metrics, fn_animate;

													fn_animate = function(index) {
														var $plates, plates;

														if (index > 0) {
															plates = [];

															$figure.find(".stack").each(function() {
																var $plate;

																if (($plate = $(this).find(".plate.last").prevAll().eq(index - 1)).length) {
																	plates.push($plate[0]);
																}
															});

															$plates = $(plates);
														} else {
															$plates = $figure.find(".stack .plate.last");
														}

														if ($plates.length) {
															$plates.css({
																'display': 'block'
															}).animate({
																'opacity': 1
															}, 200);

															$figure.find(".digit").eq(index).css({
																'opacity': 1,
																'top': '0'
															});

															my.timers.plates = window.setTimeout(function() {
																fn_animate(index + 1);
																my.timers.plates = null;
															}, 200);
														}
													};

													if (($figure = $container.find(settings.selectors.figure)).length &&
														(text = $figure.text()) !== null) {
														if (!(metrics = my.initialised($container))) {
															metrics = {};

															// split text into an array for separate 'digits'
															text = text.split("");
															$figure.html("");

															for (a = 0; a < text.length; a += 1) {
																$digit = $("<span>", {
																	'class': 'stack'
																}).append(
																	$("<span>", {
																		'class': 'digit'
																	}).text(text[a])
																);

																for (b = 0; b < (a + 1); b += 1) {
																	$digit.append(
																		$("<span>", {
																			'class': 'plate' + (b === a ? ' last' : '')
																		})
																	);
																}

																$figure.append($digit);

																if (!metrics.base_outerwidth) {
																	metrics.base_outerwidth = $digit.outerWidth(true);
																}

																$digit.css({
																	'left': (metrics.base_outerwidth * a) + 'px'
																});
															}

															// fix width of container, position plates
															$figure.css({
																'width': $figure.width() + 'px',
																'height': $figure.height() + 'px'
															});

															$figure.find(".stack").css({
																'position': 'absolute',
																'bottom': 0
															});

															my.initialised($container, true, metrics);
														}

														// re-set
														$plates = $figure.find(".plate");

														if ($plates.length > 0) {
															$figure.find(".plate").css({
																'display': 'none',
																'opacity': 0
															});

															$figure.find(".digit").css({
																'opacity': 0,
																'top': '-20px'
															});

															if (animate) {
																if (my.timers.plates) {
																	window.clearTimeout(my.timers.plates);
																	my.timers.plates = null;
																}

																// animate in
																fn_animate(0);
															}
														}
													}
												}
											},

											complete: function($container) {
												$container.addClass(settings.classes.complete);
											},

											initialised: function($container, set, metrics) {
												$container.removeClass(settings.classes.complete);

												if (set === undefined) {
													if (!!($container.data("animator-setup"))) {
														return $container.data("animator-metrics") || false;
													} else {
														return false;
													}
												} else {
													$container
														.data("animator-metrics", metrics)
														.data("animator-setup", set);

													return true;
												}
											}
										};

										my.enable();

										return cls;
									};

									$timeline.each(function() {
										var post_advance, $nav, $navNew;

										post_advance = new TimelineComplete();

										carousel = new WS.Carousel($(this), {
											'selectors': {
												'items': 'div.slide'
											},
											'pagination': false,
											'animation': {
												'automated': false,
												'easing': 'easeInOutQuint',
												'duration': 0.5,
												'type': WS.Carousel.Animations.slide
											},
											'callbacks': {
												'post_advance': post_advance
											}
										});

										post_advance.apply(carousel, [false]);

										$nav = $(this).parent().find('.navigation');		// current carousel navigation
										$navNew = $(this).find('.navigation-container'); // new home for carousel navigation

										// Move navigation in to new place within bootstrap grid
										$nav.appendTo($navNew);
									});

									TimelineComplete();

								});
							}

						} else {

							$timeline.addClass('mobile');

						}
				}
			},

			widgets: {
				donateBlock: {
					enable: function (donateBlock) {
						var slider,
							options             = {},
							currencySymbol      = donateBlock.currencySymbol,
							afterCurrencySymbol = donateBlock.afterCurrencySymbol,
							$slider             = donateBlock.$slider,
							$donateButton       = donateBlock.$donateButton,
							$amountImage        = donateBlock.$amountImage,
							$amountCopy         = donateBlock.$amountCopy,
							$amountDetails      = donateBlock.$amountDetails,
							$projectsSelect     = donateBlock.$projectsSelect,
							$fundButton         = donateBlock.$fundButton,
							$subscriptionOption = donateBlock.$subscriptionOption,
							slideMaxVal			= 500,
							priceTwoChild		= 0,
							priceMax            = slideMaxVal,
							priceOneChild       = 0,
							priceOneChilRounded;

						if (window.GLOBALS.decimal_seperator == ',') {
							priceOneChild = parseFloat( GLOBALS.currency_school_feed_cost.toString().replace(',','.') ).toFixed(2);
						} else {
							priceOneChild = parseFloat( GLOBALS.currency_school_feed_cost ).toFixed(2);
						}

						priceTwoChild = priceOneChild * 2,
						priceOneChilRounded = Math.round(priceOneChild / 10) * 10;

						if ($slider.length) {
							// Options for jquery UI slider
							options = {
								animate: true,
								range: "min",
								value: 10,
								min: 1,
								max: slideMaxVal,
								slide: function (event, ui) {
									var amount = ui.value;
									$amountCopy.val(currencySymbol + amount + afterCurrencySymbol);
									$amountCopy.trigger('change', [true]);
								}
							};

							// Create jquery UI slider
							slider = $slider.slider(options);

							// Allow input field to update jquery UI slider
							$amountCopy.on('change', function (event, triggerFromSlider) {
								var amount, numberChild, finalNumberChild, sliderVal, perChildAmount;
								amount = this.value.replace(currencySymbol, '').replace(afterCurrencySymbol, '');
								if(window.GLOBALS.decimal_seperator == ',') {
									amount = amount.replace('.','').replace(',','.');
								}
								amount = parseFloat(amount);
								if (isNaN(amount)) {
									amount = 0;
								}

								numberChild =  Math.floor(amount / priceOneChild);
								// if aid match is on increase the numberChild
								if((window.GLOBALS.country_code === 'GB' || window.GLOBALS.country_code === 'US') && window.GLOBALS.aid_match == true) {
									finalNumberChild = numberChild*2;
								}
								else finalNumberChild = numberChild;


								if (/^([\d]*)\.?([\d]{2})?$/.test(amount)) {
									$amountImage.attr('class', (numberChild < 4) ? 'image face-' + numberChild : 'image face-' + 4);
								}

								if (numberChild <= 0 ) {
									// show div
									$amountDetails.find('.details').addClass('hide');
									$('.details-1').removeClass('hide');
								} else if (numberChild == 1) {
									perChildAmount = parseFloat(priceOneChild).toFixed(2);
									if(window.GLOBALS.decimal_seperator == ',') {
										perChildAmount = perChildAmount.toString().replace('.',',');
									}
									$amountDetails.find('.details').addClass('hide');
									$amountDetails.find('.details-2').removeClass('hide');
									$amountDetails.find('.details-2 .amount').text(currencySymbol + perChildAmount + afterCurrencySymbol + ' ');
								} else if (amount < priceMax) {
									perChildAmount = parseFloat(priceOneChild * numberChild).toFixed(2);
									if(window.GLOBALS.decimal_seperator == ',') {
										perChildAmount = perChildAmount.toString().replace('.',',');
									}
									$amountDetails.find('.details').addClass('hide');
									$amountDetails.find('.details-3').removeClass('hide');
									$amountDetails.find('.details-3 .amount').text(currencySymbol + perChildAmount + afterCurrencySymbol + ' ');
									if(window.GLOBALS.country_code === 'GB' && window.GLOBALS.aid_match == true || (window.GLOBALS.country_code === 'US') && window.GLOBALS.aid_match == true) {
										if (window.GLOBALS.language_code === 'es') {
											$amountDetails.find('.details-3 .child-count').html('<span class="strikeout-orange">' + numberChild + ' niños</span> ' + finalNumberChild + ' niños');
										}
										else {
										$amountDetails.find('.details-3 .child-count').html('<span class="strikeout-orange">' + numberChild + ' children</span> ' + finalNumberChild + ' children');
										}
									}
									else {
										$amountDetails.find('.details-3 .child-count').html(finalNumberChild);
									}
								} else {
									$amountDetails.find('.details').addClass('hide');
									$amountDetails.find('.details-4').removeClass('hide');
								}

								if (!triggerFromSlider) {
									slider.slider('value', amount);
								}
								if(window.GLOBALS.decimal_seperator == ',') {
									amount = amount.toString().replace('.',',');
								}

								this.value = currencySymbol + amount + afterCurrencySymbol;
							});

							// Donate button clicks through to donate API page
							$donateButton.on('click', function (e) {
								var subscriptionType = $subscriptionOption.filter(':checked').val() || 'single',
									userSrc = $(this).attr('data-user-src'),
									target = window.GLOBALS.donate_url;

								e.preventDefault();
								if(window.GLOBALS.country_code == 'HR') {
									location.href = '/donirajte#block-croatia-donate-body-copy';
								} else {
									target += '?amount=' + $amountCopy.val().replace(currencySymbol, '').replace(afterCurrencySymbol,'') + '&type=' + subscriptionType;
									if (userSrc && userSrc !== '') {
										target += '&src=' + userSrc;
									}
									location.href = target;
								}

							});

							$fundButton.on('click', function (e) {
								e.preventDefault();
								if ($projectsSelect.val()) {
									location.href = $projectsSelect.val();
								}
							});
						}
					}
				},

				plateStackBlock: {
					enable: function ($plateStackBlock) {
						var complete = false;
						if ( !my.site.widgets.mobileVersion.isMobile() ) {
							if ($plateStackBlock.length) {
								$(window).scroll(function () {
									if ($plateStackBlock.is(':visible') && !complete && $plateStackBlock.PlateStacker) {
										$plateStackBlock.PlateStacker();
										complete = true;
									}
								});
							}
						}
					}
				},

				plateRoundabout: {
					enable: function ($plateRoundabout) {
						if ($plateRoundabout.length) {
							if (WS.JSMedia.run([['(max-width: 1140px)']])) {
								$plateRoundabout.WSRoundabout({
									'show': 1
								});
							} else {
								$plateRoundabout.WSRoundabout();
							}
						}
					}
				},

				counter: {
					enable: function ($counter) {
						$counter.each(function (i,el) {
								var od,
									complete = false,
									$el = $(el),
									$parentBlock = $el.closest('.block'),
									countvalue = $el.text().split(window.GLOBALS.thousands_seperator).join('');

								$el.empty();
								$el.attr('data-value', countvalue);
								$el.append('<div/>');
								$el = $el.find('div');
								od = new Odometer({
									el: $el.get(0),
									value: 0,
									minIntegerLen: countvalue.length,
									// Any option (other than auto and selector) can be passed in here
									format: '('+window.GLOBALS.thousands_seperator+'ddd)',
									theme: 'minimal'
								});

							if( $el.parents('.homepage-header-block-carousel').length ) {
								//
							} else {
								$(window).scroll(function () {
									if ( $parentBlock.is(':visible') ) {
										$el.text( $el.parent().attr('data-value') );
									}
								});
							}
						});

					}
				},

				child31Block: {
					enable: function (child31Block, hash, $doc) {

						var $block  = child31Block.$block,
							$inner  = child31Block.$inner,
							$header = child31Block.$header,
							$button = child31Block.$button,
							$copy   = child31Block.$copy,
							$video  = child31Block.$video,
							$iframe = $('<div class="video-wrapper" style="position: relative; z-index: -99;">' +
									'<iframe frameborder="0" height="100%" width="100%"' +
										'src="//' + $copy.text().substr( $copy.text().indexOf('://') +3 ) + '?autoplay=1&controls=0&showinfo=0&autohide=1">' +
									'</iframe>' +
								'</div>');

						$copy.remove();

						if (child31Block.$block.length) {

							// Play button
							$button.on('click', function (e) {
								e.preventDefault();

								$header.fadeOut();
								$inner.fadeOut();
								$button.parent().fadeOut(function () {
									$block.removeClass('has-cta');
									$video.remove();
									$iframe.insertAfter($inner).hide().slideDown('slow', function () {
										$('body,html').stop(true,true).animate({
											'scrollTop': $iframe.offset().top - 35
										}, 'fast');
									});
								});
							});

							// If autoplay hash found in url
							if (hash === '#startVideo') {
								$header.fadeOut();
								$inner.fadeOut();
								$button.parent().fadeOut(function () {
									$block.removeClass('has-cta');
									$video.remove();
									$iframe.insertAfter($inner).hide().slideDown('slow', function () {
										$('body,html').stop(true,true).animate({
											'scrollTop': $iframe.offset().top - 35
										}, 'fast');
									});
								});
							}

						}
					}
				},

				confirmLinks: {
					enable: function($links) {
						$links.click(function(e){
							if(confirm($(this).attr('data-confirm'))) {
								return true;
							} else {
								e.preventDefault();
							}
						});
					}
				},

				socialButtons: {
					enable: function ($facebook, $twitter, $twibbon) {
						var fbshare = location.href, twshare = location.href;

						if ($facebook.data('share') && $facebook.data('share') !== '') {
							fbshare = $facebook.data('share');
						}
						$facebook.attr('href', 'https://www.facebook.com/sharer.php?u=' + fbshare);

						if ($twitter.data('share') && $twitter.data('share') !== '') {
							twshare = $twitter.data('share');
						}
						$twitter.attr('href', 'https://twitter.com/intent/tweet?text=' + GLOBALS.twitter_share_copy + '&url=' + twshare);

						$facebook.click(function(e){
							e.preventDefault();
							window.open($(this).attr('href'),'share','width=500,height=300');
						});

						$twitter.click(function(e){
							e.preventDefault();

							window.open($(this).attr('href'),'share','width=500,height=300');
						});

						$twibbon.click(function(e){
							e.preventDefault();
							window.open($(this).attr('href') + '?PL=' + GLOBALS.country_code,'share','width=500,height=300');
						});
					}
				},

				projectDonateGiftCalc: {
					enable: function ($input, $display) {
						$input.on('keyup', function () {
							my.site.widgets.projectDonateGiftCalc.calculate($input,$display);
						});
						my.site.widgets.projectDonateGiftCalc.calculate($input,$display);
					},
					calculate: function($input,$display) {
						var val = 0;
						val = parseFloat($input.asNumber()).toFixed(2);
						val = isNaN(val) ? 0 : val;
						val = (parseFloat(val) + (parseFloat(val) * 0.25)).toFixed(2);
						$display.text($.getFormattedCurrency(val,{region: window.GLOBALS.country_code, suppressCurrencySymbol: true}));
					}
				},

				projectDonateDonateButton: {
					enable: function ($button, $target, $doc) {
						$button.on('click', function (e) {
							e.preventDefault();
							$('body,html').stop(true,true).animate({scrollTop: $target.offset().top}, 'slow');
						});
					}
				},

				projectSearchLoadMoreButton: {
					enable: function ($button, $table) {
						$button.on('click', function (e) {
							e.preventDefault();
							my.site.widgets.projectSearchLoadMoreButton.fetchPage(this.href, $button, $table);
						});
					},

					fetchPage: function (uri, $button, $table) {
						$.ajax(uri)
							.done(function (response) {
								var data, $newTable, $newButton,
									$html = $(response);

								my.site.widgets.projectSearchLoadMoreButton.updateTable($html, $table, $newTable);

								my.site.widgets.projectSearchLoadMoreButton.updateButton($html, $button, $newButton);

							});
					},

					updateTable: function ($html, $table, $newTable) {
						if ( ( $newTable = $html.find('.project-search') ).length ) {
							var $lastRow = $table.find('tr').last(),
								$newRows = $newTable.find('tr');

							$newRows.insertAfter($lastRow);
						}
					},

					updateButton: function ($html, $button, $newButton) {
						if ( ($newButton = $html.find('.load-more') ).length ) {
							$button.get(0).href = $newButton.get(0).href;
						} else {
							$button.remove();
						}
					}

				},

				iconInteractiveScroll: {
					enable : function ($icon) {
						if ($icon.length) {
							$icon.on('click', function (e) {
								e.preventDefault();
								var top;

								if ( $icon.hasClass('homepage') ) {
									top = $icon.closest('.block').next().offset().top;
								} else {
									top = $icon.parent().parent().parent().offset().top + 90;
								}

								$('html, body').animate({'scrollTop': top}, 'slow');
							});
						}
					}
				},

				mobileVersion: {
					enable: function ($video, $banner) {
						if ( my.site.widgets.mobileVersion.isMobile() ) {
							// remove video on mobile
							$video.remove();

							// remove video classes
							$('.has-video').removeClass('has-video');
						} else {
							$video.show();
						}
					},

					isMobile: function () {
						var check = (function (a, b) {
							if (
								/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
								.test(a) ||
								/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
								.test(a.substr(0, 4))
								) {
									return true;
								} else {
									return false;
								}
						})(navigator.userAgent || navigator.vendor || window.opera);
						return check;
					}
				}
			},

			flashMessage: {
				enable: function ($flashMessage) {
					$flashMessage.each(function(i,el){
						if($(el).parents('#content').length == 0) {
							var autoHeight,
							curHeight = 0;
						}

						$(el).css('height', 'auto');

						autoHeight = $(el).height();

						$(el).css('height', 0);

						$(el).animate({'height':autoHeight});

						$(el).find('.icon.close').on('click', function () {
							$(this).parents('.flash-message').animate({'height':'0'});
						});
					});
				}
			},

			projectPage: {
				enable: function ($maps, $paginate) {

					window.load_p_maps = function () {
						WS.Include.load('/includes/global_js/ws.gmap.js', function () {
								$maps.each(function () {
									var $this = $(this), $canvas, map, lat, lng, marker;

									if ((lat = $this.data("lat")) && (lng = $this.data("lng"))) {
										marker = $.trim($this.data("marker"));

										$canvas = $("<div>", {
											'class': 'gmap'
										}).appendTo($this);

										map = new WS.Gmap({
											'canvas': $canvas[0],
											'zoom': 1
										});

										map.pan(map.latlng(lat, lng), 7);

										if (marker) {
											map.add_marker(lat, lng, {
												'center': true,
												'clickable': false,
												'icon': '/assets/global_icons/marker-private-screening.png'
											});
										}
									}
								});
						});
					};

					if ($maps.length) {
						WS.Include.load('//maps.google.com/maps/api/js?sensor=false&key=AIzaSyAUwxxUUbk6pO5PqDHI-yju86zhCkN_qmw&region=GB&callback=load_p_maps');
					}

					if ($paginate.length) {
						$paginate.each(function () {
							new my.site.projectPage.ajaxPaginator(this);
						});
					}

				},

				ajaxPaginator: function($canvas, settings) {
					// parse ajax-paginating entities
					var my, cls;

					my = {
						enable: function() {
							var endpoint;

							$canvas = $($canvas);

							settings = ob_set(settings || {}, {
								'endpoint': $canvas.data("paginate-uri"),
								'first_page': 1,
								'classes': {
									'pagination': 'pagination',
									'prev': 'prev',
									'next': 'next',
									'disabled': 'disabled'
								},
								'selectors': {
									'data': 'script#data',
									'pagination': 'ul.pagination',
									'pagination_link': 'ul.pagination > li > a',
									'prev': 'li.prev',
									'next': 'li.next'
								}
							});

							my.ui = {};
							my.status = {
								'current': null,
								'count': 0
							};

							if (settings.endpoint) {
								my.getPage(settings.first_page, function(html, data) {
									if (data) {
										my.updatePagination(data);
									}
								});

								// apply events
								$canvas.on("click", settings.selectors.pagination_link, my.eventRegister("paginate"))
							}
						},

						eventRegister: function(id) {
							return function(event) {
								my.event.apply(this, [event, id]);
							};
						},

						event: function(event, id) {
							var $this = $(this), data = {};

							if (id === "paginate") {
								event.preventDefault();

								if ($this.closest(settings.selectors.next).length) {
									data.increment = 1;
								} else {
									data.increment = -1;
								}

								my.page(data.increment, function($html, data) {
									my.insertPage($html, data);
								});
							}
						},

						page: function(adjustment, after) {
							var page;

							page = my.status.current + adjustment;

							if (page > my.status.count) {
								page = my.status.count;
							} else if (page < 1) {
								page = 1;
							}

							my.getPage(page, after);
						},

						getPage: function(number, after) {
							var uri;

							if (number === my.status.current) {
								return;
							}

							uri = settings.endpoint + "/" + number;

							$.ajax(uri)
								.done(function(response) {
									var data, $html = $(response), $json;

									if (($json = $html.filter(settings.selectors.data)).length) {
										try {
											data = $.parseJSON($json.html());
											$html = $html.not(settings.selectors.data);
										} catch(e) {}
									}

									if (typeof after === "function") {
										after.apply(this, [$html, data]);
									}
								});
						},

						insertPage: function($html, data) {
							$canvas.children().not(settings.selectors.pagination).remove();
							my.ui.pagination.$list.before($html);

							if (data) {
								my.updatePagination(data);
							}
						},

						updatePagination: function(data) {
							if ((my.status = data.pagination)) {
								if (!my.ui.pagination) {
									// no current pagination - create nodes
									my.ui.pagination = {
										'$list': $("<ul>", {
											'class': 'pagination'
										})
									};

									my.ui.pagination.$list.append(
										my.ui.pagination.$prev = $("<li>", {
											'class': settings.classes.prev
										}).append(
												$("<a>", {
												'href': '#'
											}).append($('<i>',{
												'class': 'fa fa-angle-left'
											}))
										),
										my.ui.pagination.$next = $("<li>", {
											'class': settings.classes.next
										}).append(
											$("<a>", {
												'href': '#'
											}).append($('<i>',{
												'class': 'fa fa-angle-right'
											}))
										)
									);

									$canvas.append(my.ui.pagination.$list);
								}

								// update pagination
								my.ui.pagination.$prev.removeClass(settings.classes.disabled);
								my.ui.pagination.$next.removeClass(settings.classes.disabled);

								if (my.status.current === my.status.count) {
									// hide 'next'
									my.ui.pagination.$next.addClass(settings.classes.disabled);
								}

								if (my.status.current === 1) {
									// hide 'prev'
									my.ui.pagination.$prev.addClass(settings.classes.disabled);
								}
							}
						}
					};

					my.enable();

					return cls;
				}
			},

			socialLogin: {
				enable: function() {

					function statusChangeCallback(response,nl,$elm) {
						if(typeof nl == 'undefined') {
							nl = false;
						}
						if (response.status === 'connected') {
							window.FB.api('/me?fields=name,first_name,last_name,picture.width(400).height(400),email,id', function(response) {
								console.log(response);
								if(!response.email || response.email === '') {
									$.ajax(window.GLOBALS.ajax_url,{
										data: {
											action: 'set_flash',
											type: 'error',
											message: 'wsfp_social_no_email'
										},
										success: function() {
											location.href = location.href+'?socialerror'+Math.floor(Math.random() * 10000000);
										}
									});
									$elm.removeClass('loading');
								} else {
									$.ajax(window.GLOBALS.ajax_url,{
										data: {
											action: 'facebook_login',
											email: response.email,
											fb_id: response.id,
											first_name: response.first_name,
											last_name: response.last_name,
											newsletter: nl ? '1' : '',
											external_photo: response.picture.data.is_silhouette ? '' : response.picture.data.url
										},
										method: 'post',
										success: function(result) {
											location.href = result.redirect;
										}
									});
									$elm.removeClass('loading');
								}

							});
						} else {
							$.ajax(window.GLOBALS.ajax_url,{
								data: {
									action: 'set_flash',
									type: 'error',
									message: 'wsfp_social_permissions'
								},
								success: function() {
									location.href = location.href+'?socialerror'+Math.floor(Math.random() * 10000000);
								}
							});
							$elm.removeClass('loading');
						}
					}

					window.fbLogin = function(nl,$elm) {
						$elm.addClass('loading');
						window.FB.login(function(response) {
							window.FB.getLoginStatus(function(response) {
								statusChangeCallback(response,nl, $elm);
							});
						}, {scope: 'public_profile,email'});
					};

					window.fbAsyncInit = function() {
						window.FB.init({
							appId      : window.GLOBALS.fb_app_id,
							cookie     : true,
							xfbml      : true,
							version    : 'v2.2'
						});

						$('#shell').on('click','#facebook-login',function(e){
							e.preventDefault();
							window.fbLogin(false,$(this));
						});
					};

					// Load the SDK asynchronously
					(function(d, s, id) {
						var js, fjs = d.getElementsByTagName(s)[0];
						if (d.getElementById(id)) return;
						js = d.createElement(s); js.id = id;
						js.src = "//connect.facebook.net/en_US/sdk.js";
						fjs.parentNode.insertBefore(js, fjs);
					}(document, 'script', 'facebook-jssdk'));

				}
			},

			newsPagination: {
				enable: function($containers) {
					if ($containers.length) {

						$containers.each(function() {
							var $container = $(this);

							$container.on('click touchend', 'a.ajax-filter, .ajax-pagination a', function(e) {
								var container_height = $container.outerHeight(true),
									uri              = $(this).attr('href');

								e.preventDefault();

								$.ajax({
									url: uri,
									beforeSend: function(xhr) {
										var $show_more = $container.find('.show-more'),
											$div_more = $container.find('.div-more');

										$div_more.each(function(index, div) {
											div = $(div);
											div.css('height', '60px');
											$(div.data('trigger')).show();
										});
										$('html,body').animate({'scrollTop': $container.offset().top}, 300, function() {
											container_height = $container.outerHeight(true),
											$container.addClass('loading');
											$container.css('min-height', container_height);
										});
									}
								})
								.done(function(data) {
									if (typeof window.history.replaceState === 'function') {
										window.history.replaceState(null, null, uri);
									}
									$container.html(data).removeClass('loading');
									$container.css('min-height', 0);
									my.site.newsPagination.expandingFilters($container);
								});
							});
						});
					}
				},

				expandingFilters: function($container) {
					var $show_more = $container.find('.show-more'),
						$div_more = $container.find('.div-more');

					if ($div_more) {
						$div_more.each(function(index, div) {
							div = $(div);

							if (div.height() > 65) {
								div.css('height', '60px');
								$(div.data('trigger')).show();
							} else {
								div.css('height', 'auto');
								$(div.data('trigger')).hide();
							}
						});
					}

					if ($show_more.length) {
						var more_label = $show_more.data('more-label'),
						    less_label = $show_more.data('less-label');

						$show_more.click(function(event) {
							var a = $(this);

							if (a.hasClass('open')) {
								a.removeClass('open');
								a.text(more_label + ' ...');
								$(a.data('target')).css('height', '60px');
							} else {
								a.addClass('open');
								a.text(less_label + ' ...');
								$(a.data('target')).css('height', 'auto');
							}
							event.preventDefault();
						});
					}
				}
			},

			docCookies: {
				getItem: function (sKey) {
					if (!sKey) { return null; }
					return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
				},
				setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
					if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
					var sExpires = "";
					if (vEnd) {
						switch (vEnd.constructor) {
							case Number:
								sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
								break;
							case String:
								sExpires = "; expires=" + vEnd;
								break;
							case Date:
								sExpires = "; expires=" + vEnd.toUTCString();
								break;
						}
					}
					document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
					return true;
				},
				removeItem: function (sKey, sPath, sDomain) {
					if (!this.hasItem(sKey)) { return false; }
					document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
					return true;
				},
				hasItem: function (sKey) {
					if (!sKey) { return false; }
					return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
				},
				keys: function () {
					var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
					for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
					return aKeys;
				}
			},

			geoRedirect: function($content) {
				var cookie = my.site.docCookies.getItem('geo-redirect-dismissed');

				if ($content.length && cookie !== 'true') {
					vex.defaultOptions.className = 'vex-theme-mm';
					vex.open({
						unsafeContent: $('<div />').append($content.clone()).html(),
						afterClose: function() {
							my.site.docCookies.setItem('geo-redirect-dismissed', 'true', 2592000);
						}
					});
				}
			},

			responsorConfirmation: function() {
				//set the default Vex theme to MM
				vex.defaultOptions.className = 'vex-theme-mm';

				my.site.ui.$responsorConfirm.on('click', function(e) {
					var header = $(this).attr('data-header'),
						content = $(this).attr('data-content'),
						confirm = $(this).attr('data-confirm'),
						cancel = $(this).attr('data-cancel'),
						vex_message = '<h3>' + header + '</h3><p>' + content + '</p>',
						vex_action = $(this).attr('data-action');

					e.preventDefault();

					vex.dialog.confirm({
						unsafeMessage: vex_message,
						buttons: [
							$.extend({}, vex.dialog.buttons.YES, {
								text: confirm
							}),
							$.extend({}, vex.dialog.buttons.NO, {
								text: cancel,
								className: 'modal-cancel'
							}),
							$.extend({}, vex.dialog.buttons.NO, {
								text: '',
								className: 'vex-close'
							})
						],
						callback: function (value) {
							if (value) {
								window.location = vex_action;
							}
						}
					})
				});

				my.site.ui.$responsorDecline.on('click', function(e) {
					var header = $(this).attr('data-header'),
						content = $(this).attr('data-content'),
						confirm = $(this).attr('data-confirm'),
						cancel = $(this).attr('data-cancel'),
						vex_message = '<h3>' + header + '</h3><p>' + content + '</p>',
						vex_action = $(this).attr('data-action');

					e.preventDefault();

					vex.dialog.confirm({
						unsafeMessage: vex_message,
						buttons: [
							$.extend({}, vex.dialog.buttons.YES, {
								text: confirm
							}),
							$.extend({}, vex.dialog.buttons.NO, {
								text: cancel,
								className: 'modal-cancel'
							}),
							$.extend({}, vex.dialog.buttons.NO, {
								text: '',
								className: 'vex-close'
							})
						],
						callback: function (value) {
							if (value) {
								window.location = vex_action;
							}
						}
					});
				});
			},

			toggleFundraisingSummary: function() {
				if (my.site.ui.$fundraisingSummaryToggle.length && my.site.ui.$fundraisingSummaryContainer.length) {
					my.site.ui.$fundraisingSummaryToggle.on('click', function() {
						$(this).toggleClass('open');
						my.site.ui.$fundraisingSummaryContainer.toggleClass('open');
					});
				}
			},

			cookie_notification: function () {
				var notificationCookie = document.cookie.replace(/(?:(?:^|.*;\s*)notified\s*\=\s*([^;]*).*$)|^.*$/, "$1");
				var expire = new Date(new Date().setFullYear(new Date().getFullYear() + 1));

				if (notificationCookie) {
					return;
				}
				else {
					$('.cookie-notification').addClass('show-notification');
					$('.cookie-notification-hide').click(function (e) {
						e.preventDefault();
						$('.cookie-notification').css('display', 'none');
						document.cookie = 'notified=true; expires=' + expire + '; path=/';
					});

					$('.cookie-notification-hide').on({'touchstart': function (e) {
						e.preventDefault();
						$('.cookie-notification').css('display', 'none');
						document.cookie = 'notified=true; expires=' + expire + '; path=/';
					}});
				}
			},

			facebook_events: function() {
				if (window.GLOBALS.country_code === 'CZ') {
					// email links
					var $cz_email_links = $('a[href="mailto:info@marysmeals.cz"]');

					if ($cz_email_links.length) {
						$cz_email_links.click(function(ev) {
							if (window.fbq) {
								window.fbq('track', 'Contact');
							}
	 					});
					}

					// donate buttons
					var $cz_donate_buttons = $('a[href^="https://www.darujme.cz/projekt/"]');

					if ($cz_donate_buttons.length) {
						$cz_donate_buttons.click(function(ev) {
							if (window.fbq) {
								window.fbq('track', 'Lead');
							}
	 					});
					}
				}
			}
		}
	};

	my.site.enable();

	return my.site;
}(window.jQuery, window.WS, window.GLOBALS));

(function($, $doc, WS, GLOBALS) {

	var BigMaps = function($container) {
		var cls, my;

		cls = {};

		my= {
			wsgmap: null,
			active_marker: null,
			active_marker_index: null,
			markers: [],
			grouper: null,
			marker_icons: {},
			map_canvas: $container.find('.big-map-map'),

			enable: function() {
				window.load_maps = function () {
					if (typeof(window.WSGmap) === 'undefined') {
						WS.Include.load('/includes/global_js/ws.gmap.js', function () {
							my.display_map();
						});
					} else {
						my.display_map();
					}
				};

				if (typeof(window.google) === 'undefined' || typeof(window.google.maps) === 'undefined') {
					WS.Include.load('//maps.google.com/maps/api/js?sensor=false&key=AIzaSyAUwxxUUbk6pO5PqDHI-yju86zhCkN_qmw&region=GB&callback=load_maps');
				}
			},

			display_map: function() {
				my.wsgmap = new window.WSGmap({
					'canvas': $(my.map_canvas),
					'map': {
						'center': new window.google.maps.LatLng($container.data('center-lat'), $container.data('center-lng')),
						'maxZoom': 16,
						'minZoom': 5,
						'zoom': 5,
						'zoomControlOptions': {
							'style': window.google.maps.ZoomControlStyle.LARGE,
							'position': window.google.maps.ControlPosition.LEFT_CENTER
						},
						'panControl': false,
						'zoomControl': true,
						'mapTypeControl': false,
						'scaleControl': false,
						'streetViewControl': false,
						'overviewMapControl': false
					}
				});

				my.grouper = new WS.Gmap.MarkerGrouper(my.wsgmap,{
					max_zoom: 12,
					'marker': {
						'icon': new window.google.maps.MarkerImage(
							'/assets/global_icons/marker-group.png',
							new window.google.maps.Size(41, 55), /* half */
							new window.google.maps.Point(0, 0)   /* 0, 0 - normal, 0, 55 - active */
						)
					}
				});

				my.marker_icons['default'] = {
					icon: new window.google.maps.MarkerImage(
							'/assets/global_icons/ui-icon-map-marker.png',
							new window.google.maps.Size(41, 55), /* half */
							new window.google.maps.Point(0, 0)   /* 0, 0 - normal, 0, 55 - active */
						),
					icon_selected: new window.google.maps.MarkerImage(
							'/assets/global_icons/ui-icon-map-marker-selected.png',
							new window.google.maps.Size(41, 55), /* half */
							new window.google.maps.Point(0, 0)   /* 0, 0 - normal, 0, 55 - active */
					)
				};


				$container.find('.big-map-markers li').each(function() {
					var marker = {
						title: $(this).find('h3.marker-title').text(),
						description: $(this).html(),
						lng: $(this).data('lng'),
						lat: $(this).data('lat'),
						icon: $(this).data('marker-icon'),
						icon_selected: $(this).data('marker-icon-selected'),
						type: $(this).data('marker-type') ? $(this).data('marker-type') : 'default'
					};

					if (!my.marker_icons[marker.type]) {
						my.marker_icons[marker.type] = {
							icon: new window.google.maps.MarkerImage(
									marker.icon,
									new window.google.maps.Size(41, 55), /* half */
									new window.google.maps.Point(0, 0)   /* 0, 0 - normal, 0, 55 - active */
								),
							icon_selected: new window.google.maps.MarkerImage(
									marker.icon_selected,
									new window.google.maps.Size(41, 55), /* half */
									new window.google.maps.Point(0, 0)   /* 0, 0 - normal, 0, 55 - active */
							)
						};
					}

					my.markers.push(marker);
				});

				$.each(my.markers,function() {
					my.wsgmap.add_marker(this.lat, this.lng,{
						title: this.title,
						icon: my.marker_icons[this.type].icon
					});
				});


				my.grouper.group();

				$(my.wsgmap.markers).each(function(i,el) {
					var marker = this;
					window.google.maps.event.addListener(marker,'click',function(){
						var
							position = marker.position,
							span = my.wsgmap.gmap.getBounds().toSpan(),
							newcenter = {};

						marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);

						$container.find('.big-map-overlay').hide();
						$container.find('.big-map-overlay .overlay-content').html(my.markers[i].description);
						$container.find('.big-map-overlay').show();

						if (WS.JSMedia.run([['(max-width : 767px)']])) {
							$('html, body').animate({
								scrollTop: $container.find('.big-map-wrapper').offset().top
							}, 500);
						}

						var center;  // a latLng
						var offsetX = 0.25; // move center one quarter map width left
						var offsetY = 0.25; // move center one quarter map height down

						newcenter = {
							lat: position.lat(),
							lng: position.lng() - span.lng() * 0.1
						};

						my.wsgmap.gmap.panTo(newcenter);

						if (my.active_marker) {
							my.active_marker.setIcon(my.marker_icons[my.markers[my.active_marker_index].type].icon);
						}

						marker.setIcon(my.marker_icons[my.markers[i].type].icon_selected);
						my.active_marker = marker;
						my.active_marker_index = i;

					});
				});

				$container.on('click','.close',function(e) {
					e.preventDefault();
					$container.find('.big-map-overlay').hide();
					if (my.active_marker) {
							my.active_marker.setIcon(my.marker_icons[my.markers[my.active_marker_index].type].icon);
					}
					my.active_marker = null;
					my.active_marker_index = null;
				});
			}
		};

		my.enable();
	};

	$('.big-map').each(function() {
		new BigMaps($(this));
	});
}(window.jQuery, window.jQuery(document.body), window.WS, window.GLOBALS));
